<template>
    <div id="contenedor-main-listado">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoTiposObras="listadoTiposObras"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoTiposObras="listadoTiposObras"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoTiposObras',
  props: {
    listadoTiposObras: {
      type: Array,
      requited: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
